import { tv } from '@workspace/lib';

export const heroBannerVariants = tv({
  slots: {
    container: 'bg-transparent',
    slide: 'gap-0',
    backgroundWrapper: 'rounded-none',
    foreground: 'p-0',
    content: 'gap-0',
    headingDescription: 'gap-sm',
    tag: 'rounded-md bg-secondary-50 bg-opacity-70 px-sm py-xs',
    tagText: 'font-heading text-black leading-5',
    heading: 'font-heading text-4xl font-bold leading-15 md:text-6xl md:leading-14',
    descriptionWrapper: 'max-w-146.5',
    description: 'font-body text-sm font-semibold md:text-base',
    metadataWrapper: 'max-w-146.5',
    metadata: 'font-body text-sm md:text-base',
    shareIcons: 'text-white',
  },
  variants: {
    layout: {
      overlay: {},
      article: {},
    },
    size: {
      slim: {},
      medium: {},
      full: {},
    },
    contentPosition: {
      left: { content: 'max-w-175' },
      center: {},
      right: {},
    },
  },
  compoundVariants: [
    {
      layout: 'overlay',
      size: 'slim',
      class: {
        foreground: 'px-md py-2xl md:px-4xl md:py-xl',
        content: 'gap-sm',
      },
    },
    {
      layout: 'overlay',
      size: 'medium',
      class: {
        foreground: 'px-md py-2xl md:px-4xl md:py-4xl',
        content: 'gap-sm md:gap-md',
      },
    },
    {
      layout: 'overlay',
      size: 'full',
      class: {
        foreground: 'px-md py-2xl md:px-4xl md:py-5xl',
        content: 'gap-sm md:gap-lg',
      },
    },
  ],
  defaultVariants: {
    layout: 'overlay',
    size: 'medium',
    contentPosition: 'left',
  },
});
